"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_2 = __importDefault(require("react"));
var models_1 = require("../../../models");
var styles_1 = require("../../../styles");
var smallAndUp = styles_1.BREAKPOINTS.smallAndUp, lessThanSmall = styles_1.BREAKPOINTS.lessThanSmall;
var confirmPageMessageStyle = react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  text-align: center;\n  @media (", ") {\n    padding: 16px;\n  }\n  @media (", ") {\n    padding: 12px;\n  }\n"], ["\n  border: 1px solid ", ";\n  text-align: center;\n  @media (", ") {\n    padding: 16px;\n  }\n  @media (", ") {\n    padding: 12px;\n  }\n"])), styles_1.COLOR.border.base, smallAndUp, lessThanSmall);
var StyledMessage = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 1.7;\n  color: ", ";\n  word-break: break-all;\n  ", "\n"], ["\n  font-size: 14px;\n  line-height: 1.7;\n  color: ", ";\n  word-break: break-all;\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var pageType = _a.pageType;
    return pageType === models_1.FORM_PAGE_TYPE.CONFIRM && confirmPageMessageStyle;
});
var Message = function (_a) {
    var message = _a.message, color = _a.color, className = _a.className, pageType = _a.pageType;
    return (react_2.default.createElement(StyledMessage, { color: color, dangerouslySetInnerHTML: {
            __html: message,
        }, className: className, pageType: pageType }));
};
exports.Message = Message;
var templateObject_1, templateObject_2;
